/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatMarkUnreadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvUlEQVR4nN2UzUocQRCAx6AGjwoGje+QV1jw4uhu/XSgrPLnvDdRDyLmsuSUgxhy9AFUxCeQKB6UQN4hCvoAKmiIf8hK44y6zrLbzu4pDQXDdPN9XdXVHUX/9Yjj+D06FSTdQNIjYLsAsn9Adghka36uUCh05oID62ckPUa2apM4AVZ6C7sDyH4EgKsvA8hWKpXKu5Cdf38rHF9IGsJLNMF54ZiEZ9SFl8vlLl/PVgVIeuxZGQG6cWsZzkk4lTq1t812CYBtPSsgO2xbBmx/siViu26fQP9mBaRXgYBrRJsvFid7RaQP0RDAPolIjw//XfcM/FMQ2OtzUZ6BZFshAhHpS5riF5IeEI2PINsukF0i6xmwboOzOHebRs9n1izTrzUCEekOKVP0SgCkt8i6EIv0Ozf9AUgXH/9ZtcQ6WiPxk7kzID3IcEh/PsG9PSQDSc7AA19drv2UNSYykJTpNC1PD7D+Duzx2aYNg/axRgCsq6GXCMhuwNlwIwGwLSXrd9N6LgPpfaDkLr1IQDYDrOceWCzKkHNTg0D6JT1kYC01y7bh8IIGmX5rCZ4O34rAtuOfGr9zYNvzz0e64AEAC5SFZV7d8QAAAABJRU5ErkJggg==)
 */
export const ChatMarkUnreadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12.93 21.96c.25-.03.43-.23.47-.47a3 3 0 0 1 .08-.35.66.66 0 0 0-.24-.71A3 3 0 0 1 12 18v-3a3 3 0 0 1 4.35-2.68c.14.07.3.09.44.04a7 7 0 0 1 4.58.05c.3.1.63-.1.63-.41a10 10 0 1 0-18.45 5.36c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22H12c.32 0 .63-.01.93-.04Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M18 17h-1.24a3 3 0 1 1 .26 4.25 1 1 0 1 0-1.33 1.5A4.98 4.98 0 0 0 24 19a5 5 0 0 0-8-4 1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
